// src/pages/ContactPage.js
import React from 'react';
import useSEO from '../hooks/useSEO';

const ContactPage = () => {
  useSEO();

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Entre em Contato</h1>
      <p>Página em desenvolvimento - Por favor aguarde.</p>
    </div>
  );
};

export default ContactPage;
